var map = {
	"./Liker.bytecode.js": 1159,
	"./NiftyInk.bytecode.js": 1160,
	"./NiftyMain.bytecode.js": 1161,
	"./NiftyMediator.bytecode.js": 1162,
	"./NiftyRegistry.bytecode.js": 1163,
	"./NiftyToken.bytecode.js": 1164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 643;